module.exports = __webpack_public_path__ + "img/Car.5e6e0e6f.jpg";